import { useEffect, useState } from "react";
import Reveal from "@/components/base/Reveal";
import { urbanRuralSlides } from "@/mocks/home";

export default function UrbanRural() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % urbanRuralSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const slide = urbanRuralSlides[current];

  return (
    <section id="concept" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-accent-700 text-sm font-medium">
            <i className="ri-exchange-line"></i>
            城乡双向生态理念
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            乡村城市化 · 城市乡村化
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 max-w-2xl mx-auto leading-relaxed">
            一端是九宫八卦的田园仙境，一端是城市里的天然氧吧，让乡村与城市在生态中双向奔赴。
          </p>
        </Reveal>

        <Reveal>
          <div className="relative rounded-lg overflow-hidden bg-white border border-background-200">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative h-64 lg:h-auto">
                <img
                  src={slide.image}
                  alt={slide.title}
                  title={slide.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-semibold">
                    {slide.tag}
                  </span>
                </div>
              </div>

              <div className="p-8 md:p-12 flex flex-col justify-center">
                <p className="text-xs text-accent-700 font-semibold uppercase tracking-wide">
                  {slide.subtitle}
                </p>
                <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mt-2">
                  {slide.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5">
                  {slide.desc}
                </p>
                <div className="flex flex-wrap gap-2.5 mt-6">
                  {slide.points.map((point) => (
                    <span
                      key={point}
                      className="inline-flex items-center gap-1.5 text-xs md:text-sm px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700"
                    >
                      <i className="ri-check-line"></i>
                      {point}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120} className="mt-8 flex items-center justify-center gap-4">
          <button
            type="button"
            onClick={() => setCurrent((prev) => (prev - 1 + urbanRuralSlides.length) % urbanRuralSlides.length)}
            className="w-10 h-10 rounded-full bg-white border border-background-200 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-white hover:border-primary-500 transition-colors cursor-pointer"
            aria-label="上一个"
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <div className="flex gap-2">
            {urbanRuralSlides.map((s, i) => (
              <button
                key={s.id}
                type="button"
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${
                  i === current ? "w-8 bg-accent-500" : "w-2 bg-background-300 hover:bg-background-400"
                }`}
                aria-label={`切换到 ${s.tag}`}
              ></button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => setCurrent((prev) => (prev + 1) % urbanRuralSlides.length)}
            className="w-10 h-10 rounded-full bg-white border border-background-200 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-white hover:border-primary-500 transition-colors cursor-pointer"
            aria-label="下一个"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </Reveal>
      </div>
    </section>
  );
}